(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Track announcement bar height so the fixed desktop header stays 24px below it.
  // When the bar scrolls out of view, collapse the offset so the header slides up.
  // --announcement-bar-height-static holds the real bar height (load/resize only,
  // never collapsed) for layout that must not shift on scroll, e.g. .zd-hero.
  (function() {
    const bar = document.querySelector('.announcement-bar-section');
    let barHeight = 0;

    function updateBarHeight() {
      barHeight = bar ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height-static', barHeight + 'px');
      applyOffset();
    }

    function applyOffset() {
      const visible = window.scrollY < barHeight;
      const offset = visible ? barHeight : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', offset + 'px');
    }

    updateBarHeight();
    window.addEventListener('scroll', applyOffset, { passive: true });
    if (bar && window.ResizeObserver) {
      new ResizeObserver(updateBarHeight).observe(bar);
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-advent-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.zd-advent-products').forEach((section) => {
    const dialog = section.querySelector('.zd-advent-products__modal');
    if (!dialog) return;
    const content = dialog.querySelector('.zd-advent-products__modal-content');
    const cards = [...section.querySelectorAll('.zd-advent-products__card')];

    section.querySelectorAll('[data-advent-product]').forEach((button) => {
      button.addEventListener('click', () => {
        const template = cards[Number(button.dataset.adventProduct)].querySelector('.zd-advent-products__experience');
        content.replaceChildren(template.content.cloneNode(true));
        dialog.showModal();
      });
    });

    // Slide out to the bottom before actually closing; the open slide-in is pure CSS ([open])
    const closeDialog = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      dialog.classList.add('is-closing');
      if (getComputedStyle(dialog).animationName === 'none') {
        // Reduced motion: no animation runs, so no animationend would ever fire
        dialog.classList.remove('is-closing');
        dialog.close();
        return;
      }
      dialog.addEventListener(
        'animationend',
        () => {
          dialog.classList.remove('is-closing');
          dialog.close();
        },
        { once: true }
      );
    };

    dialog.querySelector('.zd-advent-products__modal-close').addEventListener('click', closeDialog);
    // Esc: run the same exit animation instead of the instant native close
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });

    // Mouse drag-to-scroll for the ribbon (touch and trackpads scroll natively).
    // A drag must not also count as a click on TELL ME MORE, so a flag swallows the
    // click that follows it; pointer-events is left alone (toggling it on press breaks taps).
    const ribbon = section.querySelector('.zd-advent-products__ribbon');
    const DRAG_THRESHOLD = 5;
    let drag = null;
    let suppressClick = false;

    ribbon.addEventListener('pointerdown', (event) => {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { startX: event.clientX, startScroll: ribbon.scrollLeft, moved: false };
    });

    ribbon.addEventListener('pointermove', (event) => {
      if (!drag) return;
      const dx = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(dx) < DRAG_THRESHOLD) return;
      if (!drag.moved) {
        drag.moved = true;
        ribbon.classList.add('is-dragging');
        ribbon.setPointerCapture(event.pointerId);
      }
      ribbon.scrollLeft = drag.startScroll - dx;
    });

    const endDrag = () => {
      if (!drag) return;
      if (drag.moved) {
        suppressClick = true;
        // Snap back to a card once the drag ends
        ribbon.classList.remove('is-dragging');
      }
      drag = null;
    };
    ribbon.addEventListener('pointerup', endDrag);
    ribbon.addEventListener('pointercancel', endDrag);

    ribbon.addEventListener(
      'click',
      (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    // Images are draggable by default, which would start a native image drag instead
    ribbon.addEventListener('dragstart', (event) => event.preventDefault());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', () => content.replaceChildren());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-manual"] && !Shopify.designMode) return;
  try {
    
(() => {
  const STORAGE_KEY = 'zd_manual_unlocked_forms';
  const HTML2PDF_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';

  const readUnlocked = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  };

  const saveUnlocked = (formId) => {
    try {
      const ids = readUnlocked();
      if (!ids.includes(formId)) localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, formId]));
    } catch (error) {
      // Storage unavailable (private mode etc.) — unlock still applies for this page view.
    }
  };

  let html2pdfPromise;
  const loadHtml2pdf = () => {
    if (window.html2pdf) return Promise.resolve(window.html2pdf);
    html2pdfPromise =
      html2pdfPromise ||
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HTML2PDF_SRC;
        script.onload = () => resolve(window.html2pdf);
        script.onerror = () => {
          html2pdfPromise = null;
          reject(new Error('Failed to load html2pdf'));
        };
        document.head.append(script);
      });
    return html2pdfPromise;
  };

  // Lazy images inside hidden panels never load on their own.
  const loadImages = (docs) =>
    Promise.all(
      docs.flatMap((doc) =>
        [...doc.querySelectorAll('img')].map((img) => {
          img.loading = 'eager';
          if (img.complete) return null;
          return new Promise((resolve) => {
            img.addEventListener('load', resolve, { once: true });
            img.addEventListener('error', resolve, { once: true });
          });
        })
      )
    );

  const AVOID_BREAK = 'img, p, li, h1, h2, h3, h4, blockquote';

  // html2pdf places page breaks using the inner page height floored to whole CSS px,
  // but slices the canvas using floor(canvas.width * pageRatio), where the canvas is
  // 1588px wide (the 210mm container is 793.7px, x2 scale, rounded up). At 14mm the
  // two differ by 1px per page and after ~15 pages a line gets cut in half.
  // 14.0835mm is the middle of the band where both are exactly 1016px (at scale 2).
  const PAGE_MARGIN_MM = 14.0835;

  // Glyph descenders (e.g. the "p" in "Step") hang below an element's box.
  const DESCENDER_ALLOWANCE = 8;
  // Each guide, and each guide's "Smart Stacking Guide" section, starts a new page.
  const FORCED_BREAK = '.zd-manual-doc--print + .zd-manual-doc--print, .zd-manual-doc__guide';

  // Headings, and a short label paragraph right before a list (e.g. "Stack"), must stay
  // on the same page as the start of what follows them.
  const keepWithNextTarget = (el) => {
    const next = el.nextElementSibling;
    if (!next) return null;
    const isHeading = /^H[1-4]$/.test(el.tagName);
    const isListLabel = el.tagName === 'P' && /^(UL|OL)$/.test(next.tagName);
    if (!isHeading && !isListLabel) return null;
    return next.matches(AVOID_BREAK) ? next : next.querySelector(AVOID_BREAK) || next;
  };

  // Shifts an element down by `gap` px. In block flow a margin would collapse with the
  // previous sibling's bottom margin (moving it less than asked), so a spacer is
  // inserted instead; flex/grid items don't collapse margins, and a spacer there would
  // add an extra `gap`, so those get margin-top. Either way the actual shift is
  // measured and corrected, since a spacer also un-collapses the adjacent margins.
  const pushDown = (el, gap) => {
    const before = el.getBoundingClientRect().top;
    let apply;
    if (/flex|grid/.test(getComputedStyle(el.parentElement).display)) {
      const margin = parseFloat(getComputedStyle(el).marginTop) || 0;
      apply = (px) => (el.style.marginTop = `${margin + px}px`);
    } else {
      const spacer = document.createElement('div');
      spacer.setAttribute('aria-hidden', 'true');
      // Inline display: Dawn's base.css hides `div:empty`, which would make the spacer a no-op.
      spacer.style.display = 'block';
      el.before(spacer);
      apply = (px) => (spacer.style.height = `${px}px`);
    }
    apply(gap);
    const moved = el.getBoundingClientRect().top - before;
    if (Math.abs(moved - gap) >= 0.5) apply(Math.max(0, gap - (moved - gap)));
  };

  // Runs after html2pdf has laid out the container. Walks breakable elements in
  // document order and fixes the first violation, then re-measures: forced breaks
  // must start a page; nothing may be cut by a page boundary; headings and list
  // labels move together with the first block after them.
  const fixStraddlers = (container, pageHeight) => {
    const stuck = new Set();
    const selector = `${FORCED_BREAK}, ${AVOID_BREAK}`;
    for (let guard = 0; guard < 500; guard++) {
      const top = container.getBoundingClientRect().top;
      let pushStart = null;
      const offender = [...container.querySelectorAll(selector)].find((el) => {
        if (stuck.has(el)) return false;
        const rect = el.getBoundingClientRect();
        const start = rect.top - top;
        const offset = start % pageHeight;
        if (el.matches(FORCED_BREAK)) {
          if (offset < 0.5 || pageHeight - offset < 0.5) return false;
          pushStart = start;
          return true;
        }
        const next = keepWithNextTarget(el);
        const end = (next ? next.getBoundingClientRect().bottom : rect.bottom) - top + DESCENDER_ALLOWANCE;
        if (end - start >= pageHeight) return false;
        if (Math.floor(start / pageHeight) === Math.floor((end - 1) / pageHeight)) return false;
        pushStart = start;
        return true;
      });
      if (!offender) return;
      pushDown(offender, pageHeight - (pushStart % pageHeight));
      // Safety net: never retry an element that didn't land on the next page.
      if (offender.getBoundingClientRect().top - top < Math.ceil(pushStart / pageHeight) * pageHeight - 1) {
        stuck.add(offender);
      }
    }
  };

  // Clones the guide docs into one wrapper (hidden tab panels included) for export.
  const exportPdf = async (docs, fileName) => {
    const html2pdf = await loadHtml2pdf();
    if (document.fonts) await document.fonts.ready;
    await loadImages(docs);

    const wrapper = document.createElement('div');
    docs.forEach((doc) => {
      const clone = doc.cloneNode(true);
      clone.hidden = false;
      clone.classList.add('zd-manual-doc--print');
      wrapper.append(clone);
    });

    const worker = html2pdf()
      .set({
        margin: [PAGE_MARGIN_MM, 0, PAGE_MARGIN_MM, 0],
        filename: fileName,
        image: { type: 'jpeg', quality: 0.95 },
        // scrollX/Y: 0 — otherwise html2canvas offsets the capture by the page scroll and renders blank pages.
        html2canvas: { scale: 2, useCORS: true, windowWidth: 1280, scrollX: 0, scrollY: 0 },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        // Pagination is done by fixStraddlers, not html2pdf: its pagebreak plugin pads
        // with fixed heights from stale measurements, so later pushes shift its forced
        // breaks and its `avoid` leaves mid-page gaps / misses elements.
        pagebreak: { mode: [] },
      })
      .from(wrapper);

    await worker.toContainer();
    fixStraddlers(worker.prop.container, worker.prop.pageSize.inner.px.height);
    await worker.save();
  };

  const unlock = (section) => {
    const locked = section.querySelector('.zd-manual__cta--locked');
    const unlocked = section.querySelector('.zd-manual__cta--unlocked');
    if (!unlocked) return;
    if (locked) locked.hidden = true;
    unlocked.hidden = false;
  };

  // Lock page scroll while a viewer is open; every way of closing it (close button,
  // backdrop click, Esc) fires the dialog's `close` event, which releases the lock.
  // Own class rather than Dawn's .overflow-hidden, which its drawers also toggle.
  const SCROLL_LOCK_CLASS = 'zd-scroll-lock';
  const showViewer = (dialog) => {
    if (!dialog || dialog.open) return;
    document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    dialog.showModal();
    // Mobile: the tab row scrolls sideways, so bring the active tab into view
    const activeTab = dialog.querySelector('.zd-manual__tab[aria-selected="true"]');
    if (activeTab) activeTab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };

  const sections = document.querySelectorAll('.zd-manual[data-klaviyo-form-id]');
  // The section whose CTA opened the Klaviyo popup; its viewer opens when the popup
  // closes after a successful submit (success-step button set to "Close form", or the ×).
  let signupSection = null;
  const submittedForms = new Set();
  // Debug: ?manual_debug=1 shows "OPEN THE MANUAL" without signing up (not persisted);
  // ?manual_debug=reset clears the saved unlock so the signup flow can be retested.
  const debugParam = new URLSearchParams(window.location.search).get('manual_debug');
  if (debugParam === 'reset') {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // Storage unavailable — nothing to reset.
    }
  }
  const debugUnlock = debugParam === '1';
  const unlockedForms = readUnlocked();

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-zd-open-manual]');
    const section = [...sections].find((s) => s.openGuide);
    if (!link || !section) return;
    event.preventDefault();
    section.openGuide(link.dataset.zdOpenManual);
  });

  sections.forEach((section) => {
    const formId = section.dataset.klaviyoFormId;
    const locked = section.querySelector('.zd-manual__cta--locked');
    const unlocked = section.querySelector('.zd-manual__cta--unlocked');
    const dialog = section.querySelector('.zd-manual__viewer');

    if (locked) {
      locked.addEventListener('click', () => {
        signupSection = section;
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      });
    }

    if (!unlocked || !dialog) return;

    if (debugUnlock || unlockedForms.includes(formId)) unlock(section);

    unlocked.addEventListener('click', () => showViewer(dialog));
    dialog.addEventListener('close', () => document.documentElement.classList.remove(SCROLL_LOCK_CLASS));
    dialog.querySelector('.zd-manual__viewer-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const body = dialog.querySelector('.zd-manual__viewer-body');
    const docs = [...dialog.querySelectorAll('.zd-manual-doc')];
    const tabs = [...dialog.querySelectorAll('.zd-manual__tab')];
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const currentIndex = Number(tab.dataset.guideIndex);
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        docs.forEach((doc, i) => (doc.hidden = i !== currentIndex));
        // Mobile: the tab row scrolls sideways — bring the picked tab fully into view.
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        body.scrollTop = 0;
      });
    });

    // Links elsewhere on the page (PDP "See the full … ritual") open the manual on their
    // ritual's guide: through the CTA, so a locked manual asks for the signup first
    section.openGuide = (name) => {
      const tab = tabs.find((t) => t.dataset.guideName === name);
      if (tab) tab.click();
      const cta = unlocked.hidden ? locked : unlocked;
      if (cta) cta.click();
    };

    // One download for every guide in the viewer, as a single PDF.
    const download = dialog.querySelector('.zd-manual__download');
    const setBusy = (busy) => {
      download.disabled = busy;
      download.querySelector('.zd-manual__download-label').hidden = busy;
      download.querySelector('.zd-manual__download-loading').hidden = !busy;
    };

    download.addEventListener('click', async () => {
      setBusy(true);
      try {
        await exportPdf(docs, body.dataset.allFileName);
      } catch (error) {
        console.error('[zd-manual] PDF export failed', error);
      } finally {
        setBusy(false);
      }
    });
  });

  // Visitors Klaviyo already recognises (clicked through from a Klaviyo email, signed up
  // on another form, etc.) skip the signup. klaviyo.js is loaded async by the Klaviyo
  // app embed; its loader stub queues isIdentified() until then, but the stub may not
  // exist yet when this runs, so poll for it briefly.
  // Never resolve a promise *with* window.klaviyo: the stub is a Proxy that returns a
  // function for every property, including `then`, so the promise would treat it as a
  // thenable, call klaviyo.then() (queued as a bogus Klaviyo event) and never settle.
  const whenKlaviyoReady = (timeoutMs = 10000) =>
    new Promise((resolve) => {
      const started = Date.now();
      const check = () => {
        if (typeof window.klaviyo?.isIdentified === 'function') return resolve(true);
        if (Date.now() - started > timeoutMs) return resolve(false);
        setTimeout(check, 250);
      };
      check();
    });

  const isKlaviyoIdentified = async () => {
    if (!(await whenKlaviyoReady())) return false;
    try {
      // Stays pending until the visitor accepts cookies (Klaviyo doesn't identify anyone
      // before consent), then settles immediately — so no timeout: late consent still
      // unlocks. A promise that never settles is harmless.
      return await window.klaviyo.isIdentified();
    } catch (error) {
      return false;
    }
  };

  const lockedSections = [...sections].filter((section) => {
    const unlocked = section.querySelector('.zd-manual__cta--unlocked');
    return unlocked && unlocked.hidden;
  });

  if (lockedSections.length) {
    isKlaviyoIdentified().then((identified) => {
      if (identified !== true) return;
      lockedSections.forEach((section) => {
        saveUnlocked(section.dataset.klaviyoFormId);
        unlock(section);
      });
    });
  }

  const openViewer = (section) => {
    const dialog = section.querySelector('.zd-manual__viewer');
    showViewer(dialog);
  };

  // Closes the Klaviyo popup for this form by clicking its own close button (several
  // Klaviyo popups can be open at once, each in its own modal-form-container).
  // Clicking it fires Klaviyo's `close` event, which opens the viewer below.
  const closeKlaviyoForm = (formId) => {
    const form = document.querySelector(`[data-testid="klaviyo-form-${formId}"]`);
    const closeButton = form?.closest('[data-testid="modal-form-container"]')?.querySelector('.klaviyo-close-form');
    if (closeButton) {
      closeButton.click();
    } else if (signupSection?.dataset.klaviyoFormId === formId) {
      // Klaviyo's markup changed or the popup is gone: still get the visitor to the manual.
      const section = signupSection;
      signupSection = null;
      openViewer(section);
    }
  };

  // After a successful submit, leave the success step ("You're in!") up for the
  // section's delay, then close the popup. The timer starts on the `viewedStep` that
  // follows the submit (the success view appearing), with a fallback in case that
  // event never arrives.
  let pendingAutoClose = null;
  const scheduleAutoClose = (formId) => {
    if (!pendingAutoClose || pendingAutoClose.formId !== formId || pendingAutoClose.timer) return;
    clearTimeout(pendingAutoClose.fallback);
    pendingAutoClose.timer = setTimeout(() => {
      pendingAutoClose = null;
      closeKlaviyoForm(formId);
    }, pendingAutoClose.delay);
  };

  window.addEventListener('klaviyoForms', (event) => {
    if (!event.detail) return;
    const { type, formId } = event.detail;

    if (type === 'submit') {
      submittedForms.add(formId);
      sections.forEach((section) => {
        if (section.dataset.klaviyoFormId !== formId) return;
        saveUnlocked(formId);
        unlock(section);
      });

      const delaySeconds = Number(signupSection?.dataset.successCloseDelay);
      if (signupSection?.dataset.klaviyoFormId === formId && delaySeconds > 0) {
        pendingAutoClose = { formId, delay: delaySeconds * 1000, timer: null };
        pendingAutoClose.fallback = setTimeout(() => scheduleAutoClose(formId), 1500);
      }
    }

    if (type === 'viewedStep') scheduleAutoClose(formId);

    if (type === 'close') {
      if (pendingAutoClose?.formId === formId) {
        clearTimeout(pendingAutoClose.timer);
        clearTimeout(pendingAutoClose.fallback);
        pendingAutoClose = null;
      }
      if (submittedForms.has(formId) && signupSection?.dataset.klaviyoFormId === formId) {
        const section = signupSection;
        signupSection = null;
        openViewer(section);
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-mood-cabinet"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-stacks-more]').forEach((button) => {
    button.addEventListener('click', () => {
      const stacks = button.previousElementSibling;
      if (!stacks || !stacks.classList.contains('zd-mood-cabinet__stacks')) return;
      stacks.classList.add('is-expanded');
      button.remove();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-ritual-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ribbon = document.querySelector('.zd-ritual-products__ribbon');
  if (!ribbon) return;

  ribbon.addEventListener('dragstart', (event) => event.preventDefault());

  let isDragging = false;
  let dragMoved = false;
  let dragStartX = 0;
  let dragStartScrollLeft = 0;
  let lastMoveX = 0;
  let lastMoveTime = 0;
  let velocity = 0;
  let momentumRAF = null;

  const stopMomentum = () => {
    if (momentumRAF) {
      cancelAnimationFrame(momentumRAF);
      momentumRAF = null;
    }
    ribbon.classList.remove('is-momentum');
  };

  const stepMomentum = () => {
    ribbon.scrollLeft -= velocity;
    velocity *= 0.94;
    if (Math.abs(velocity) < 0.5) {
      stopMomentum();
      return;
    }
    momentumRAF = requestAnimationFrame(stepMomentum);
  };

  ribbon.addEventListener('mousedown', (event) => {
    stopMomentum();
    isDragging = true;
    dragMoved = false;
    dragStartX = event.pageX;
    dragStartScrollLeft = ribbon.scrollLeft;
    lastMoveX = event.pageX;
    lastMoveTime = performance.now();
    velocity = 0;
    ribbon.classList.add('is-dragging');
  });

  window.addEventListener('mousemove', (event) => {
    if (!isDragging) return;
    const delta = event.pageX - dragStartX;
    if (Math.abs(delta) > 3) dragMoved = true;
    ribbon.scrollLeft = dragStartScrollLeft - delta;

    const now = performance.now();
    const dt = now - lastMoveTime;
    if (dt > 0) velocity = ((event.pageX - lastMoveX) / dt) * 16;
    lastMoveX = event.pageX;
    lastMoveTime = now;
  });

  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    ribbon.classList.remove('is-dragging');
    if (Math.abs(velocity) > 1) {
      ribbon.classList.add('is-momentum');
      momentumRAF = requestAnimationFrame(stepMomentum);
    }
  });

  ribbon.addEventListener(
    'click',
    (event) => {
      if (dragMoved) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    { capture: true }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zd-tiktok"] && !Shopify.designMode) return;
  try {
    
(() => {
  const videos = document.querySelector('.zd-tiktok__videos');
  if (videos) {
    videos.addEventListener('dragstart', (event) => event.preventDefault());

    let isDragging = false;
    let dragMoved = false;
    let dragStartX = 0;
    let dragStartScrollLeft = 0;
    let lastMoveX = 0;
    let lastMoveTime = 0;
    let velocity = 0;
    let momentumRAF = null;

    const stopMomentum = () => {
      if (momentumRAF) {
        cancelAnimationFrame(momentumRAF);
        momentumRAF = null;
      }
      videos.classList.remove('is-momentum');
    };

    const stepMomentum = () => {
      videos.scrollLeft -= velocity;
      velocity *= 0.94;
      if (Math.abs(velocity) < 0.5) {
        stopMomentum();
        return;
      }
      momentumRAF = requestAnimationFrame(stepMomentum);
    };

    videos.addEventListener('mousedown', (event) => {
      stopMomentum();
      isDragging = true;
      dragMoved = false;
      dragStartX = event.pageX;
      dragStartScrollLeft = videos.scrollLeft;
      lastMoveX = event.pageX;
      lastMoveTime = performance.now();
      velocity = 0;
      videos.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', (event) => {
      if (!isDragging) return;
      const delta = event.pageX - dragStartX;
      if (Math.abs(delta) > 3) dragMoved = true;
      videos.scrollLeft = dragStartScrollLeft - delta;

      const now = performance.now();
      const dt = now - lastMoveTime;
      if (dt > 0) velocity = ((event.pageX - lastMoveX) / dt) * 16;
      lastMoveX = event.pageX;
      lastMoveTime = now;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      videos.classList.remove('is-dragging');
      if (Math.abs(velocity) > 1) {
        videos.classList.add('is-momentum');
        momentumRAF = requestAnimationFrame(stepMomentum);
      }
    });

    videos.addEventListener(
      'click',
      (event) => {
        if (dragMoved) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      { capture: true }
    );
  }

  const dialog = document.querySelector('.zd-tiktok__modal');
  if (!dialog) return;

  const content = dialog.querySelector('.zd-tiktok__modal-content');
  const closeButton = dialog.querySelector('.zd-tiktok__modal-close');
  const productCta = dialog.querySelector('.zd-tiktok__modal-cta');

  const stopAndClear = () => {
    content.replaceChildren();
  };

  document.querySelectorAll('.zd-tiktok__video[data-video-id]').forEach((button) => {
    button.addEventListener('click', () => {
      const { videoId, redirectUrl } = button.dataset;

      const iframe = document.createElement('iframe');
      iframe.className = 'zd-tiktok__modal-iframe';
      iframe.src = `https://www.tiktok.com/embed/v2/${videoId}?autoplay=1`;
      iframe.allow = 'autoplay; encrypted-media; fullscreen';
      iframe.allowFullscreen = true;
      iframe.setAttribute('scrolling', 'no');
      content.replaceChildren(iframe);

      if (productCta) productCta.href = redirectUrl;

      dialog.showModal();
    });
  });

  closeButton.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', stopAndClear);
})();

  } catch(e) { console.error(e); }
})();
})();
